// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._4lQlF6Oyx{position:fixed;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:white;z-index:2;opacity:1.0;visibility:hidden;overflow:scroll;-webkit-overflow-scrolling:touch}._4qvRv8PMx{opacity:0.0;transition:opacity 0.5s;transition-delay:1s}._38XijfLMx{opacity:1.0;visibility:visible}._2yKNt85Ex{overflow:hidden}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"container": "_4lQlF6Oyx",
	"animated-container": "_4qvRv8PMx _4lQlF6Oyx",
	"animatedContainer": "_4qvRv8PMx _4lQlF6Oyx",
	"visible": "_38XijfLMx",
	"no-scroll": "_2yKNt85Ex",
	"noScroll": "_2yKNt85Ex"
};
module.exports = exports;
